// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"32":"c709a6","224":"21c061"}[chunkId] + ".js";
};